<template>
	<div>
		<b-carousel :autoplay="false" :indicator-inside="false">
			<b-carousel-item v-for="(img, i) in _images" :key="i">
				<section class="">
					<div class="image is-square">
						<img
							:style="{ cursor: 'zoom-in' }"
							@click="showModalImage(img)"
							:src="img.thumbProduct.indexOf('blob:') == -1 ? $backendUrl + img.thumbProduct : img.thumbProduct"
							:alt="_alt"
						/>
					</div>
				</section>
				<b-modal :active.sync="isImageModalActive" width="1200">
					<div class="left-click" v-on:click="prev()"></div>
					<div class="right-click" v-on:click="next()"></div>
					<div class="image product-full-view">
						<b-button
							v-on:keyup.left.native="prev()"
							v-on:click="prev()"
							class="image_left_button"
							outlined
							:title="$t('Previous')"
							><svg
								aria-hidden="true"
								focusable="false"
								data-prefix="fas"
								data-icon="angle-left"
								role="img"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 256 512"
								class="svg-inline--fa fa-angle-left fa-w-8 fa-lg"
							>
								<path
									fill="currentColor"
									d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
									class=""
								></path></svg
						></b-button>
						<b-button
							v-on:keyup.right="next()"
							v-on:click="next()"
							class="image_right_button"
							outlined
							:title="$t('Next')"
							><svg
								aria-hidden="true"
								focusable="false"
								data-prefix="fas"
								data-icon="angle-right"
								role="img"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 256 512"
								class="svg-inline--fa fa-angle-right fa-w-8 fa-lg"
							>
								<path
									fill="currentColor"
									d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
									class=""
								></path></svg
						></b-button>
						<img
							:src="
								$data.image.filename.indexOf('blob:') == -1 ? $backendUrl + $data.image.filename : $data.image.filename
							"
							:alt="_alt"
						/>
					</div>
				</b-modal>
			</b-carousel-item>
			<template slot="indicators" slot-scope="props">
				<div class="image is-96x96">
					<img :src="$backendUrl + _images[props.i].thumb96" :alt="_alt" />
				</div>
			</template>
		</b-carousel>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			isImageModalActive: false,
			image: { filename: '' },
			image_index: 0,
		}
	},
	props: ['_images', '_alt'],
	computed: {
		imageCount() {
			return this._images && this._images.length
		},
	},
	methods: {
		showModalImage: function (img) {
			this.image = img
			this.isImageModalActive = true
		},
		next: function () {
			this.image_index = this.image_index + 1
			if (this.image_index > this._images.length - 1) {
				this.image_index = 0
			}
			console.log('IMAGE_INDEX:', this.image_index)
			this.image = this._images[this.image_index]
		},
		prev: function () {
			this.image_index = this.image_index - 1
			if (this.image_index < 0) {
				this.image_index = this._images.length - 1
			}
			console.log('IMAGE_INDEX:', this.image_index)
			this.image = this._images[this.image_index]
		},
	},
	mounted() {
		this.image = this._images[0]
		var _this = this
		document.onkeydown = function (e) {
			if (e.keyCode == 37) {
				_this.prev()
			}
			if (e.keyCode == 39) {
				_this.next()
			}
			console.log(e.keyCode)
		}
	},
}
</script>

<style scoped>
.is-active .al img {
	filter: grayscale(0%);
}
.al img {
	filter: grayscale(100%);
}
.product-full-view img {
	max-width: 95vw;
	max-height: 95vh;
	width: auto;
	height: auto;
	margin: auto;
}
.image_left_button {
	position: absolute;
	left: 25px;
	top: calc(50% - 25px);
	border-radius: 25px;
}
.image_right_button {
	position: absolute;
	right: 25px;
	top: calc(50% - 25px);
	border-radius: 25px;
}
.right-click {
	width: 49vw;
	margin: 0;
	height: 90vh;
	position: absolute;
	right: 0;
	z-index: 1;
	bottom: 0;
}
.left-click {
	width: 49vw;
	margin: 0;
	height: 90vh;
	position: absolute;
	left: 0;
	z-index: 1;
	bottom: 0;
}
</style>
